import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_docs/docs/tos")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="mx-auto max-w-3xl py-8 sm:py-10">
      <h1 className="mb-6 font-bold text-2xl sm:text-3xl">Terms of Service</h1>
      <p className="mb-8 text-gray-500 text-sm">Last updated: 2024-08-08</p>

      <p className="mb-6">
        Welcome to the web application provided by Open Farming Technologies
        FZ-LLC ("Open Farming", "we", "us", or "our"). These terms of service
        ("Terms") govern your access to and use of our web application,
        including any content, functionality, and services offered on or through
        our web application (the "Web App").
      </p>

      <p className="mb-6">
        Please read these Terms carefully before you start to use the Web App.
        By using the Web App or by clicking to accept or agree to the Terms when
        this option is made available to you, you accept and agree to be bound
        and abide by these Terms. If you do not want to agree to these Terms,
        you must not access or use the Web App.
      </p>

      <h2 className="mt-8 mb-4 font-bold text-xl sm:text-2xl">1. Parties</h2>
      <p className="mb-6">
        These Terms are a binding contract between you and Open Farming. "You"
        and "your" refer to the individual or entity using the Web App.
      </p>

      <h2 className="mt-8 mb-4 font-bold text-xl sm:text-2xl">
        2. Eligibility
      </h2>
      <p className="mb-6">
        The Web App is intended for use by individuals aged 18 and older. By
        accessing or using the Web App, you represent and warrant that you are
        at least 18 years old.
      </p>

      <h2 className="mt-8 mb-4 font-bold text-xl sm:text-2xl">
        3. Accounts and Security
      </h2>
      <p className="mb-6">
        To access and use certain features of the Web App, you may be required
        to create an account. You are responsible for safeguarding the password
        that you use to access the Web App. You agree not to disclose your
        password to any third party.
      </p>

      <h2 className="mt-8 mb-4 font-bold text-xl sm:text-2xl">
        4. Intellectual Property Rights
      </h2>
      <p className="mb-6">
        The Web App is owned and operated by Open Farming. The Web App and its
        entire contents, features, and functionality are owned by Open Farming,
        its licensors, or other providers of such material. All rights not
        expressly granted are reserved by Open Farming.
      </p>
    </div>
  );
}
